import { actionTypes } from "../utils";

export const types = {
  ...actionTypes('SEND_EMAIL'),
};